import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenService } from '../../services/authen.service';
import { PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { DataManager } from '@syncfusion/ej2-data';
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';
import { MyDataAdaptor } from '../../helpers/grid.adaptor';

@Component({
    selector: '',
    templateUrl: 'principal.html',
})
export class PrincipalComponent implements OnInit {
    items: any = null;
    checked: boolean = true;
    data: DataManager;
    pageSettings: PageSettingsModel;
    fields: Object = { text: 'label', value: 'value' };
    constructor(private http: HttpService, private helper: HelperService) {

        this.pageSettings = { pageSize: 20 };
    }

    ngOnInit() {
        this.search();
    }
    onActionFailure(e: Error): void {
        this.helper.alert(e.message);
    }
  
    search() {
        this.data = new DataManager({ url: `${this.http.baseUrl}api/Principal/GetPage`, adaptor: new MyDataAdaptor(this.helper), crossDomain: true });
    }
   
}
